export default class RemovedSportsModifier {
    constructor(modelKeyRepository) {
        this._modelKeyRepository = modelKeyRepository;
    }

    modify(content) {
        if (content.sports === undefined) {
            return;
        }

        const sports = content.sports.remove;

        if (sports !== undefined) {
            for (let i = 0; i < sports.length; i++) {
                this._modelKeyRepository.removeSport(sports[i]);
            }
        }
    }
}



// WEBPACK FOOTER //
// ./js/repositories/modifier/RemovedSportsModifier.js